import React, {useEffect, useState} from 'react';
import {formatSimmsDateTimeKorean} from "../commonmethod/CommonMethod";
import {Skeleton} from "../skeleton/Skeleton";
import {useSelector} from "react-redux";

function ReadOnlyInputBasic({ value, type}) {
    const [textValue, setTextValue] = useState("");
    // const loading = useSelector(state => state.api.skeleton);
    const loading = false;
    useEffect(() => {
        setTextValue(handleSetValue(value?.name?? value));
    }, [value]);

    const handleSetValue = (value) => {
        const korValue = value
        let valued
        if (value) {
            if(type==="date") {
                valued = formatSimmsDateTimeKorean(korValue);
            } else {
                valued = korValue;
            }
        }else{
            valued=''
        }
        return valued;
    }

    return (
        <>
        {!loading ?
                <input
                    type={"text"}
                    className={"read-only-input cursor-default"}
                    value={textValue}
                    readOnly={true}
                />
                :
                <Skeleton className={'w-full h-[30px]'}></Skeleton>
        }
        </>
    );
}

export default ReadOnlyInputBasic;